var _rect, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonthly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 26,
    height: 22,
    rx: 3,
    fill: "#336094"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92058 15V7.245H10.9216L13.9136 13.988H13.5836L16.5756 7.245H17.5656V15H16.5316V8.796H16.8946L14.1006 15H13.3856L10.5916 8.796H10.9656V15H9.92058Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthly);
export default __webpack_public_path__ + "static/media/monthly.1239909e114f7d74bc3c5e7b53efad0d.svg";
export { ForwardRef as ReactComponent };